import React from 'react';
import { motion } from 'framer-motion';

export const Particle = ({ emoji, initialPosition, angle, speed }) => {
  const angleInRad = angle * (Math.PI / 180);
  const xDistance = Math.cos(angleInRad) * speed * 20;
  const yDistance = Math.sin(angleInRad) * speed * 20;
  
  return (
    <motion.div
      className="absolute text-4xl"
      initial={{ 
        x: initialPosition.x,
        y: initialPosition.y,
        scale: 0.4,
        opacity: 1
      }}
      animate={{
        x: initialPosition.x + xDistance,
        y: initialPosition.y - yDistance,
        scale: 1,
        opacity: 0
      }}
      transition={{
        duration: 1.8,
        ease: [0.2, 0.8, 0.2, 1],
        opacity: { 
          duration: 1.8,
          ease: [0, 0, 0.2, 1]
        }
      }}
    >
      {emoji}
    </motion.div>
  );
};